import $ from 'jquery'
import React, { Component } from 'react'
import { connect } from "react-redux"
import * as actions from '../../actions/actions.jsx'
import bg_img from '../../images/dark_bg.png'
import expired from '../../images/ico_timeout1.png'
import '../../stylesheet/sessionout.css'

const mapStateToProps = state =>
    ({
        optionState: state.selectedTabReducer.selectedTabReducer
    })
    const mapDispatchToProps = dispatch =>
    ({
        clearInput() {
            dispatch(
                actions.clearInputAction()
            )
        },
        clearProfile(){
            dispatch(
                actions.clearProfileAction()
            )
        }
    })
class SessionOut extends Component {
    gotologin=(e)=>{
        localStorage.clear();
        this.props.clearInput();
        this.props.clearProfile()
        this.props.history.push('/');
    }
    render() {
        const height = $(window).height();
    
        return (
            <div className="col-sm-12 session" style={{ backgroundImage: `url(${bg_img})`, minHeight: `${height}px` }}>
                <div className="col-sm-12 sessionoutformbox" >
                    <div className="row">
                        <div className="offset-3 col-sm-6" style={{marginTop:"15px"}}>
                            <img src={expired} alt="expired"/>
                        </div>
                        <div className="col-sm-12" style={{ color: "#f1f1f1", marginTop: "15px" }}>
                            <span style={{ fontSize: "21px", marginLeft: "31px", fontWeight: "500" }}> Your Session has Expired</span>
                        </div>
                        <div className="col-sm-12" style={{marginTop:"15px",marginLeft:"92px", color:"#207bde"}} onClick={this.gotologin.bind(this)}>
                            Click here to login
                       
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SessionOut);



// WEBPACK FOOTER //
// ./src/components/sessionout/sessionout.jsx